/**
 * Utilidades para resolver nombres desde catálogos del sistema
 * (almacenes, empleados, productos, etc.)
 */

// Minúsculas y sin diacríticos: quien busca escribe "lucia" o "almeria" sin tilde
// y espera encontrar "Lucía" y "Almería". NFD separa la letra de su acento y el
// rango ̀-ͯ son justamente esos acentos ya sueltos.
const normalizarParaBusqueda = (texto) =>
    String(texto ?? "")
        .toLowerCase()
        .normalize("NFD")
        .replace(/[̀-ͯ]/g, "");

class CatalogUtils {
    /**
     * Resuelve el nombre de un almacén a partir de su código
     * @param {string|number} codigo - Código del almacén
     * @param {Array} almacenes - Array de almacenes
     * @returns {string} Nombre del almacén o el código si no se encuentra
     */
    static getNombreAlmacen(codigo, almacenes) {
        if (codigo == null || codigo === "") return "";
        const cod = String(codigo).trim();
        const alm = (almacenes ?? []).find((a) => String(a.CODIGO).trim() === cod);
        return alm ? alm.NOMBRE : cod;
    }

    /**scon
     * Resuelve el nombre de un empleado/usuario a partir de su ID
     * @param {string|number} id - ID del empleado
     * @param {Array} empleados - Array de empleados/usuarios
     * @returns {string} Nombre del empleado o el ID si no se encuentra
     */
    static getNombreEmpleado(id, empleados) {
        if (id == null || id === "") return "";
        const key = String(id).trim();
        const emp = (empleados ?? []).find((u) => String(u.id).trim() === key);
        // Intenta primero 'nombre', luego 'username', luego devuelve el ID
        return emp ? (emp.nombre || emp.username) : key;
    }

    /**
     * Verifica si un texto incluye otro, ignorando mayúsculas y acentos
     * @param {string} haystack - Texto donde buscar
     * @param {string} needle - Texto a buscar
     * @returns {boolean} true si needle está vacío o aparece en haystack
     */
    static textIncludes(haystack, needle) {
        if (!needle) return true;
        return normalizarParaBusqueda(haystack).includes(normalizarParaBusqueda(needle));
    }
}

export default CatalogUtils;
